<template>
    <draggable
        v-if="tree" 
        ref="draggable"
        :class="{'droparea': supportsDraggedElement, 'dragactive': dragActive,}"
        :list="tree"
        :move="this.$root.onMove"
        :filter="'.popper'"
        :group="{name: 'base'}"
        :animation="100"
        :scroll="true"
        :disabled="disabled"
        :swap-threshold="0.5"
        :touch-start-threshold="50"
        :inverted-swap-threshold="0.5"
        :invert-swap="true"
        :empty-insert-threshold="0"
        :prevent-on-filter="false"
        :delay="0"
        @start="dragStart"
        @end="dragEnd"
    >
        <transition-group
            tag="div"
            :class="{'transition-group': true, 'transition-group-empty': !tree.length}"
            style="position: relative;"
        >
            <block
                v-for="component in existingTreeElements"
                :key="'existing_tree'+component.id"
                v-bind="{data: component, tree: component.tree, description: component.description, dragged: dragged, locked: locked}"
                @remove="remove"
                @update="update"
                @dragstart="dragstart"
                @dragend="dragend"
                @focus="focus"
                @unfocus="unfocus"
            />
        </transition-group>
    </draggable>
    <div
        v-else
        class="droparea"
    />
</template>

<script>
    import draggable from 'vuedraggable';

    export default {
        name: 'Container',
        components: {'draggable': draggable},
        props: {
            'id': {
                type: Number,
                default: null,
            },
            'tree': {
                type: Array,
                default: function () { return [] }
            },
            'active':  {
                type: Boolean,
                default: false,
            },
            'description': {
                type: String,
                default: '' 
            },
            'dragged': {
                validator: function(){ return true },
                default: false 
            },
            'locked': {
                type: Boolean,
                default: false
            },
            'default': {
                type: Object,
                default: function(){ return {} },
            },
            'supports': {
                'type': Array,
                'default': function() { return ['editable', 'btn', 'image', 'variable']}
            },
        },
        data: function(){
            return {
                disabled: false,
            }
        },
        computed: {
            dragActive: function() {
                return this.$root.draggedType ? true : false;
            },
            supportsDraggedElement: function(){
                if (!this.$root.draggedType) {
                    return true;
                }

                if (this.supports.length == 0) {
                    return true;
                }

                if (this.supports.includes(this.$root.draggedType)) {
                    return true;
                }

                return false;
            },
            existingTreeElements: function(){
                return this.tree.filter(el => el.registered && el.tree);
            }
        },
        methods: {
            remove: function(id, event){
                this.$emit('remove', id, event);
            },
            focus: function(id, event){
                this.disabled=true;
                this.$emit('focus', id, event);
            },
            unfocus: function(id, event){
                this.disabled=false;
                this.$emit('unfocus', id, event);
            },
            update: function(id, data, event){
                this.$emit('update', id, data, event);
            },
            dragstart: function(id, name, event){
                this.$emit('dragstart', id, name, event);
            },
            dragend: function(event){
                this.$emit('dragend', event);
            },
            dragStart: function(event){
                if(this.locked && event.item.__vue__.data.id == this.data.id ) {
                    return;
                }
                this.$emit('dragstart', event.item.__vue__.data.id, event.item.__vue__.data.type, event);
            },
            dragEnd: function(event){
                this.$emit('dragend', event);
                this.$root.onEnd();
            }
        }
    }
</script>
